module.exports = __webpack_public_path__ + "static/media/campusImgD.f27f15b9.png";